import { Component, OnInit } from '@angular/core';
import { BreadcrumbService } from "@services";
import { Breadcrumb } from "@models";
import { Observable } from "rxjs";

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: [ './breadcrumb.component.scss' ]
})
export class BreadcrumbComponent implements OnInit {

  // tslint:disable-next-line: no-unused-variable
  breadcrumbs$: Observable<Breadcrumb[]>;
  lastSection: any;
  mapRoutes: any;

  constructor(private breadcrumbService: BreadcrumbService) {
    this.breadcrumbs$ = breadcrumbService.breadcrumbs$;
  }

  ngOnInit() {
    this.breadcrumbService.getView$.subscribe(last => {
      this.lastSection = last
    });
    this.breadcrumbs$.subscribe(r => {
      try {
        const [ label ] = r.filter(this.getLast);
        this.mapRoutes = label?.label;
      } catch (e) {
        console.error('Ah ocurrido un error Admin:', e);
        throw e;
      }
    })
  }

  isInboxPath(b: any): boolean {
    return b?.url === '';
  }

  getLast = (element: any, index: number, array: any) => {
    if (index === array.length - 1) {
      return element;
    }
  }

}
